<template>
  <div>
    <Home />
  </div>
</template>

<script>
import Home from "@/components/Home/index.vue";
export default {
  components: {
    Home,
  },
};
</script>

<style></style>
